import { useProperty } from '@spotify-internal/remote-config-integration-react';
import { profileProtectionsRollout } from '@lib/remoteConfig/properties';

export const useProfileProtections = () => {
  const isProfileProtectionsEnabled = useProperty(profileProtectionsRollout);

  return { isProfileProtectionsEnabled };
};
